export function getShopName(fullDomain) {
  if (fullDomain) {
    return Shopify.shop;
  }

  return IS_SHOPIFY_ENV
    ? Shopify.shop.split('.myshopify.com')[0]
    : 'studtack';
};
